import React from 'react';
import PropTypes from 'prop-types';
import css from './StudentsCell.css';
import StyledButton from 'common/StyledButton';
import { imageStyle } from '../utils/images';
import Icon from 'SF/MaterialIcon';

function StudentsCell(props) {

  const getName = () => props.groupSession 
    ? "Show Participants" 
    : `${props.participants[0].firstName} ${props.participants[0].lastName}`;

  const onClick = () => props.groupSession 
    ? props.handleGroupSession()
    : props.openStudentFolder(props.participants[0].id, props.participants[0].studentType !== 'Active');

  const getStudentAvatar = () => (
    <div
      className={css['image']}
      style={imageStyle(props.participants[0].uuid, true)}
      role="img"
    />
  );

  const getGroupIcon = () => (
    <div className={css['image']} role="img">
      <Icon icon='group' aria-hidden='true' />
    </div>
  );

  const getImage = () => props.groupSession ? getGroupIcon() : getStudentAvatar();

  const getSubtitle = () => {
    if ( props.groupSession || props.participants[0].studentType !== 'Active' ) return null;
    return <div>{props.participants[0].studentId}</div>;
  };

  return (
    <td>
      <div className={css['students-cell']}>
        {getImage()}
        <div className={css['name-container']}>
          <StyledButton asLink onClick={onClick}>
            {getName()}
          </StyledButton>
          {getSubtitle()}
        </div>
      </div>
    </td>
  );
}

StudentsCell.propTypes = {
  participants: PropTypes.array.isRequired,
  openStudentFolder: PropTypes.func.isRequired,
  handleGroupSession: PropTypes.func.isRequired,
  groupSession: PropTypes.bool,
};

export default StudentsCell;
